<template>
  <div class="chat-func-btns">
    <div v-if="!showList" class="show-row">
      <div v-for="(item, index) in showBtns" :key="index" @click="onLink(item)" class="item">
        <!-- <message-center :show="item.showHot" :message-type="item.messageType"> -->
        <!-- <template #content> -->
        <img v-if="item && item.icon" class="icon" :src="item.icon" />
        <div class="title">{{ item.title }}</div>
        <!-- </template> -->
        <!-- </message-center> -->
      </div>
      <!-- <div @click="openList" class="item">
        <img class="icon" />
        <div class="title">更多功能</div>
      </div> -->
    </div>
    <div v-else class="toggle-wrap">
      <Swiper
        class="swiper"
        :options="swiperOptions"
        :class="[`swiper-height-${rowNum}`]"
        @slide-change="onSwiperChange"
      >
        <swiper-slide v-for="(row, indx) in matrix" :key="indx">
          <div v-for="(row2, index) in row" :key="index" class="list">
            <div v-for="(item, idx) in row2" :key="idx" class="item" @click="onLink(item)">
              <!-- <MessageCenter
                :show="item.showHot"
                :message-type="item.messageType"
              >
                <template #content> -->
              <img v-if="item && item.icon" class="icon" :src="item.icon" />
              <div class="title">{{ item.title }}</div>
              <!-- </template> -->
              <!-- </MessageCenter> -->
            </div>
          </div>
        </swiper-slide>
      </Swiper>
      <div v-if="matrix && matrix.length" class="swiper-dot-box">
        <div
          v-for="(item, index) in matrix"
          :key="index"
          class="swiper-dot-item"
          :class="{ active: index === current }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  props: {
    colspan: {
      type: Number,
      default: 4
    },
    rowspan: {
      type: Number,
      default: 2
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    rowNum() {
      return this.rowspan
    },
    colNum() {
      return this.colspan
    }
  },
  data() {
    return {
      swiperOptions: {
        direction: 'horizontal',
        loop: false,

        on: {
          click(swiper, e) {}
        }
      },
      showList: false,
      foldBtn: {
        // 收起按钮
        id: 'fold',
        icon: 'https://pharmacyimg.docbook.com.cn/mini_doctor/chat-func-btn-icon/shouqi.png',
        title: '收起'
      },
      moreBtn: {
        // 更多按钮
        id: 'more',
        icon: 'https://pharmacyimg.docbook.com.cn/mini_doctor/chat-func-btn-icon/gengduo.png',
        title: '更多功能'
      },
      indicatorColor: '#fff',
      indicatorActiveColor: '#0089FF',
      current: 0,
      showBtns: [],
      matrix: []
    }
  },
  watch: {
    list: {
      handler(n) {
        if (n && n.length) {
          const pageCount = this.rowNum * this.colNum // 每页有几个图标
          // 给每一页第一行最后一个添加收起按钮
          let arr = n.reduce((res, item) => {
            if (res.length % pageCount === this.colNum - 1) {
              res.push(this.foldBtn)
            }
            res.push(item)
            return res
          }, [])
          let catchLastRow = [] // 最后一页最后一行数组的引用
          arr = arr.reduce((res, item, index) => {
            // 根据每页数量分页
            if (index % pageCount === 0) {
              res.push([])
            }
            const target = res[res.length - 1]
            // 根据每行数量进行分行
            if (index % this.colNum === 0) {
              target.push([])
            }
            const temp = target[target.length - 1]
            catchLastRow = temp
            temp.push(item)
            return res
          }, [])

          // 最后一行样式错误添加空白占位, 并且把收取按钮放到最右侧
          if (catchLastRow.length !== this.colNum) {
            const len = catchLastRow.length
            catchLastRow.length = this.colNum
            catchLastRow.fill({}, len, this.colNum)
            // 修复多页收取按钮没有在最右侧
            if (arr.length && arr[arr.length - 1].length === 1) {
              const index = catchLastRow.findIndex(item => item.id === 'fold')
              catchLastRow.splice(index, 1) // 找到了就删除收起，没找到是-1删除最后一个空按钮
              catchLastRow.push(this.foldBtn) // 最后一页第一行最后添加收起按钮
            }
          }
          this.matrix = arr
          // 当按钮需要多列的时候才展示更多按钮
          this.showBtns = n.slice(0, this.colNum - 1)
          if (n.length > this.colNum - 1) {
            this.showBtns.push(this.moreBtn)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 点击按钮
    onLink(item) {
      // 折叠菜单
      if (!item.id) {
        // 优化展位按钮
        return
      }
      // current.value = 0
      if (item.id === 'fold') {
        this.showList = false
        return
      }
      if (item.id === 'more') {
        this.showList = true
        return
      }
      // 打开菜单
      this.$emit('link', item)
      // showList.value = false
    },

    // 切换分页
    onSwiperChange(e) {
      this.current = e.activeIndex
    },
    closeFuncList() {
      this.showList = false
    }
  }
}
</script>

<style lang="scss" scoped>
// 最高可所以是10行
@for $i from 1 through 20 {
  .swiper-height-#{$i} {
    height: 2.773333rem * $i;
  }
}
.chat-func-btns {
  position: relative;
  background: #f6f6f6;
  .show-row {
    position: relative;
    padding: 0.341333rem 0 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    z-index: 10;

    .item {
      flex: 1;
      overflow: hidden;
      .icon {
        margin: 0 auto;
        display: block;
        width: 1.365333rem;
        height: 1.365333rem;
      }
      .title {
        margin-top: 0.170667rem;
        padding-bottom: 0.213333rem;
        font-size: 0.512rem;
        line-height: 0.682667rem;
        font-weight: 400;
        color: #162b40;
        text-overflow: ellipsis;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .list {
    @extend .show-row;
  }
  .toggle-wrap {
    // position: absolute;
    // left: 0;
    // right: 0;
    // bottom: -2.773333rem;
    background: #f6f6f6;
    // z-index: 2;
  }

  .swiper-dot-box {
    padding-top: 0.512rem;
    padding-bottom: 0.512rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .swiper-dot-item {
      margin-left: 0.128rem;
      margin-right: 0.128rem;
      width: 0.426667rem;
      height: 0.170667rem;
      border-radius: 0.085333rem;
      background: #fff;
      transition: all 0.4s linear;

      &.active {
        margin-left: 0;
        margin-right: 0;
        width: 0.853333rem;
        background: #0089ff;
      }
    }
  }
}
</style>
